import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  root: {
    background: 'none',
    padding: '6px 8px !important',
    border: 'none',
    outline: 'none',
    whiteSpace: 'nowrap',
    textTransform: 'none',
    color: theme.palette.primary.main,
    fontSize: 14,
    fontWeight: 500,
    letterSpacing: 0,
    lineHeight: '20px',
    '&:hover, &:focus, &:active': {
      padding: '6px 8px !important',
      color: theme.palette.primary.main,
      background: 'none',
      border: 'none',
      outline: 'none',
    },
  },
}));
